import {FullDocument} from '@/interfaces/document';
import {Allocation} from '@/repositories/beneva-api/endpoints/allocations';
import {Attachment} from '@/repositories/beneva-api/endpoints/attachments';
import {DocumentContextProvider} from './context/document-context-provider';
import {DocumentContent} from './document-content';
import {DocumentRepositoryProvider} from './repository/document-repository-provider';
import {DocumentUtilsProvider} from './utils/document-utils-provider';

type Props = {
  document: FullDocument;
  allocations?: Allocation[];
  attachments?: Attachment[];
};

export const Document = ({document, allocations, attachments}: Props) => {
  return (
    <DocumentRepositoryProvider document={document} allocations={allocations} attachments={attachments}>
      <DocumentUtilsProvider>
        <DocumentContextProvider>
          <DocumentContent />
        </DocumentContextProvider>
      </DocumentUtilsProvider>
    </DocumentRepositoryProvider>
  );
};
